// extracted by mini-css-extract-plugin
export default {"content":"content--YaZjK","tab":"tab--y4PUV"};